import React from 'react'
import { render } from 'react-dom'

import './index.css'
import Root from './Root'
import registerServiceWorker from './registerServiceWorker'

const root = document.getElementById('root')

render(<Root />, root)
registerServiceWorker()

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./Root', () => {
    const NextApp = require('./Root').default
    render(<NextApp />, root)
  })
}



// WEBPACK FOOTER //
// ./src/index.js